export default {
  'code': 0,
  'message': 'success',
  'data': {
    'chinaTotalUpdateTime': '2020-02-04 16:15:21',
    'chinaTotal': {
      'confirm': 20502,
      'suspect': 23214,
      'dead': 426,
      'heal': 669,
      'confirmDesc': '',
      'suspectDesc': '',
      'deadDesc': '',
      'healDesc': '',
      'heavy': 0,
      'heavyDesc': ''
    },
    'virusInfo': ['北京发现41起聚集性病例 涉及120余人', '河南累计确诊566例，新增73例确诊病例', '安徽新增68例确诊病例，累计408例确诊病例'],
    'dataFrom': '               数据来源国家及地方卫生健康委',
    'chinaDayModify': {
      'confirm': 3266,
      'suspect': 1656,
      'dead': 65,
      'heal': 194,
      'confirmDesc': '3266',
      'suspectDesc': '1656',
      'deadDesc': '65',
      'healDesc': '194',
      'heavy': 0,
      'heavyDesc': ''
    },
    'notice': '7:00-10:00为更新高峰，数据有滞后请谅解'
  }
}
